import { ForgotPasswordForm } from '@/components/auth/forgot-password-form'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_public/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage(): JSX.Element {
  return <ForgotPasswordForm />
}
